var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{staticClass:"mdn-Menu-top-event",attrs:{"href":"#","title":"Conheça as iniciativas de Acessibilidade da Claro"},on:{"click":function($event){$event.preventDefault();return _vm.openAcessibility()}}},[_c('span',{staticClass:"mdn-Icon-pcd mdn-Icon--sm",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }